/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { CreateSberBeneficiaryMutationRequest, CreateSberBeneficiaryMutationResponse, CreateSberBeneficiary400, CreateSberBeneficiary401, CreateSberBeneficiary409, CreateSberBeneficiary429, CreateSberBeneficiary500, CreateSberBeneficiary502, CreateSberBeneficiary503 } from "../entities/CreateSberBeneficiary";

function getCreateSberBeneficiaryUrl() {
  const res = { method: 'POST', url: `/api/v1/payouts/beneficiary` as const }
  return res
}

/**
 * @description Создаёт анкету бенефициара (получателя средств) в Sber API — раздел «Безопасные сделки»,
 * схема «бенефициар-исполнитель». Используется перед первой выплатой водителю.
 * **Требования:**
 * - Аутентификация по заголовкам `user-id` и `city-id`
 * - Поддерживаемые типы: `individual` (резидент РФ) и `individual_non_resident` (нерезидент). Заполняется ровно одно поле.
 * - ИНН — 12 цифр
 * - `account` — только реквизиты СБП: `phone` (11–13 цифр, код страны с ведущими нулями) и `bankBIC` (9 цифр)
 * - Даты — формат `YYYY-MM-DD`
 * **Важно:**
 * - Поля `beneficiaryId`, `beneficiaryType`, `nominalAccountId` проставляет сервис — передавать их не нужно
 * - После успешного создания Сбер **асинхронно** (5–15 мин) переводит анкету в статус `ACTIVATED`
 * - Выплаты на бенефициара возможны только после активации
 * - Сервис является **прокси**: связку `driver_id ↔ beneficiary_id` хранит вызывающий сервис
 * @summary Создание анкеты бенефициара-исполнителя
 * {@link /api/v1/payouts/beneficiary}
 */
export async function createSberBeneficiary(data: CreateSberBeneficiaryMutationRequest, config: Partial<RequestConfig<CreateSberBeneficiaryMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreateSberBeneficiaryMutationResponse, ResponseErrorConfig<CreateSberBeneficiary400 | CreateSberBeneficiary401 | CreateSberBeneficiary409 | CreateSberBeneficiary429 | CreateSberBeneficiary500 | CreateSberBeneficiary502 | CreateSberBeneficiary503>, CreateSberBeneficiaryMutationRequest>({ method : "POST", url : getCreateSberBeneficiaryUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}